export enum FeedbackStep {
  Role = 'role',
  Rating = 'rating',
  ClassroomRating = 'classroom-rating',
  Category = 'category',
  Issues = 'issues',
  Comment = 'comment',
  TutorTransition = 'tutor-transition',
  DetailedFeedback = 'detailed-feedback',
  AdditionalPractice = 'additional-practice',
  Done = 'done',
}

export enum FeedbackSurveyType {
  AfterLessonFeedback = 'after_lesson_feedback',
  AfterFirstLessonFeedback = 'after_first_lesson_feedback',
  AfterFirstLessonWithNewTutorFeedback = 'after_first_lesson_with_new_tutor_feedback',
}

export enum FeedbackRole {
  Parent = 'PARENT',
  Student = 'STUDENT',
}

export enum FeedbackCategory {
  LearningExperience = 'LEARNING_EXPERIENCE',
  Connection = 'CONNECTION',
}

export enum AdditionalPractice {
  Yes = 'YES',
  No = 'NO',
}
